module.exports = __webpack_public_path__ + "static/media/Lexy360-Banner.f7f89bfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Lexy360-Banner.jpg
// module id = 114
// module chunks = 0